import React, { useId, useRef } from 'react';
import './Modal.css';
import { IoClose } from 'react-icons/io5';
import useModalErisim from '../../hooks/useModalErisim';

// hideCloseButton: sağ üstteki ✕ gizlenir (pencere yalnız kendi butonuyla kapansın istendiğinde).
// FE-80: role="dialog" + aria-modal + başlık bağlantısı; Esc (✕ görünüyorsa), Tab döngüsü, kapanınca odak geri.
export default function Modal({ isOpen, onClose, children, title, style, overlayStyle, className = "", hideTitle = false, hideCloseButton = false }) {
    const pencereRef = useRef(null);
    const baslikId = useId();
    useModalErisim(isOpen, pencereRef, onClose, !hideCloseButton);
    if (!isOpen) return null;

    const handleOverlayMouseDown = (event) => {
        if (event.target === event.currentTarget) {
            onClose?.();
        }
    };

    const baslikVar = !hideTitle && title !== undefined && title !== null && title !== "";
    return (
        <div className="custom-modal-overlay" style={overlayStyle} onMouseDown={handleOverlayMouseDown}>
            <div className={`custom-modal ${className}`.trim()} style={style}
                ref={pencereRef} role="dialog" aria-modal="true" tabIndex={-1}
                {...(baslikVar ? { "aria-labelledby": baslikId } : typeof title === "string" && title ? { "aria-label": title } : {})}>
                {!hideCloseButton && (
                    <button className="modal-close-button" onClick={onClose} aria-label="Kapat">
                        <IoClose size={20} />
                    </button>
                )}
                {!hideTitle && <span className='modal-title' id={baslikId}>{title}</span>}
                <div className="modal-content">
                    {children}
                </div>
            </div>
        </div>
    );
}
